// extracted by mini-css-extract-plugin
var _1 = "pins-module__pin___CD9rp";
export { _1 as "pin" }
